import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {Grid, Paper, Typography} from "@material-ui/core";


class Talon extends Component {
    render() {
        let northCard = convertCardPlayed(this.props.northCard);
        let eastCard = convertCardPlayed(this.props.eastCard);
        let southCard = convertCardPlayed(this.props.southCard);
        let westCard = convertCardPlayed(this.props.westCard);

        switch (this.props.currentPlayerOnLead) {
            case 0:
                northCard = (this.props.northCard !== "")? <Paper style={{paddingLeft:10, paddingRight:10}}>{northCard}</Paper>: northCard;
                break;
            case 1:
                eastCard = (this.props.eastCard !== "")? <Paper style={{paddingLeft:10, paddingRight:10}}>{eastCard}</Paper>: eastCard;
                break;
            case 2:
                southCard = (this.props.southCard !== "")? <Paper style={{paddingLeft:10, paddingRight:10}}>{southCard}</Paper>: southCard;
                break;
            case 3:
                westCard = (this.props.westCard !== "")? <Paper style={{paddingLeft:10, paddingRight:10}}>{westCard}</Paper>: westCard;
                break;
        }

        return (
            <Grid container direction={"row"} justify={"space-between"} alignContent={"space-between"} xs={12} style={{height: '100%', padding:10}}>

                <Grid item xs={4}/>
                <Grid item xs={4}>
                    <Grid container justify={"center"}>
                        {northCard}
                    </Grid>
                </Grid>
                <Grid item xs={4}/>

                <Grid item xs={4}>
                    <Grid container justify={"flex-start"}>
                        {westCard}
                    </Grid>
                </Grid>
                <Grid item xs={4}/>
                <Grid item xs={4}>
                    <Grid container justify={"flex-end"}>
                        {eastCard}
                    </Grid>
                </Grid>

                <Grid item xs={4}/>
                <Grid item  xs={4}>
                    <Grid container justify={"center"}>
                        {southCard}
                    </Grid>
                </Grid>
                <Grid item xs={4}/>
                {/*<div className="rTableBody">*/}
                    {/*<div className="rTableRow">*/}
                        {/*<div className="rTableCell aligntextcenter minwidth">&nbsp;</div>*/}
                        {/*<div className="rTableCell aligntextcenter minwidth">*/}

                        {/*</div>*/}
                        {/*<div className="rTableCell aligntextcenter minwidth">&nbsp;</div>*/}
                    {/*</div>*/}
                    {/*<div className="rTableRow">*/}
                        {/*<div className="rTableCell aligntextcenter minwidth"><span className="white">WWW</span></div>*/}
                        {/*<div className="rTableCell aligntextcenter minwidth"><span className="white">WWW</span></div>*/}
                        {/*<div className="rTableCell aligntextcenter minwidth"><span className="white">WWW</span></div>*/}
                    {/*</div>*/}
                    {/*<div className="rTableRow">*/}
                        {/*<div className="rTableCell minwidth">*/}
                            {/*<div id="PbnPlay4">{westCard}</div>*/}
                        {/*</div>*/}
                        {/*<div className="rTableCell aligntextcenter minwidth">&nbsp;</div>*/}
                        {/*<div className="rTableCell aligntextright minwidth">*/}
                            {/*<div id="PbnPlay2">{eastCard}</div>*/}
                        {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className="rTableRow">*/}
                        {/*<div className="rTableCell aligntextcenter minwidth">&nbsp;</div>*/}
                        {/*<div className="rTableCell aligntextcenter minwidth">&nbsp;</div>*/}
                        {/*<div className="rTableCell aligntextcenter minwidth">&nbsp;</div>*/}
                    {/*</div>*/}
                    {/*<div className="rTableRow">*/}
                        {/*<div className="rTableCell aligntextcenter minwidth">&nbsp;</div>*/}
                        {/*<div className="rTableCell aligntextcenter minwidth">*/}
                            {/*<div id="PbnPlay3">{southCard}</div>*/}
                        {/*</div>*/}
                        {/*<div className="rTableCell aligntextcenter minwidth">&nbsp;</div>*/}
                    {/*</div>*/}
                {/*</div>*/}
            </Grid>
        );
    }
}

function convertCardPlayed(theCard) {
    switch (theCard.substring(0, 1)) {
        case 'S':
            return (
                <>
                    <Typography variant={"subtitle1"} inline style={{color:'#000000'}}>
                        &spades;
                    </Typography>
                    <Typography inline variant={"subtitle1"}>
                        {theCard.substring(1, 2)}
                    </Typography>
                </>
            );
        case 'H':
            return (
                <>
                    <Typography variant={"subtitle1"} inline style={{color:'#F44336'}}>
                        &hearts;
                    </Typography>
                    <Typography inline variant={"subtitle1"}>
                        {theCard.substring(1, 2)}
                    </Typography>
                </>
            );
        case 'D':
            return (
                <>
                    <Typography variant={"subtitle1"} inline style={{color:'#F44336'}}>
                        &diams;
                    </Typography>
                    <Typography inline variant={"subtitle1"}>
                        {theCard.substring(1, 2)}
                    </Typography>
                </>
            );
        case 'C':
            return (
                <>
                    <Typography variant={"subtitle1"} inline style={{color:'#000000'}}>
                        &clubs;
                    </Typography>
                    <Typography inline variant={"subtitle1"}>
                        {theCard.substring(1, 2)}
                    </Typography>
                </>
            );
    }

    return <><Typography variant={"subtitle1"} inline>&nbsp;</Typography></>;
}

Talon.propTypes = {
    currentPlayerOnLead: PropTypes.number.isRequired,
    northCard: PropTypes.string.isRequired,
    eastCard: PropTypes.string.isRequired,
    southCard: PropTypes.string.isRequired,
    westCard: PropTypes.string.isRequired
}

function mapStateToProps(state, ownProps){
    return {
        currentPlayerOnLead: state.pbnData.currentPlayerOnLead,
        northCard: state.pbnData.northCard,
        eastCard: state.pbnData.eastCard,
        southCard: state.pbnData.southCard,
        westCard: state.pbnData.westCard
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Talon)